import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography
} from '@mui/material';

const TypingIndicator = () => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount(prev => (prev + 1) % 4);
    }, 800);

    return () => clearInterval(interval);
  }, []);

  const dots = '.'.repeat(dotCount);

  return (
    <div style={{ fontSize: '14px', marginBottom: '20px' }}>
      Thinking{dots}
    </div>
  );
};

export default TypingIndicator;